import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import styles from "src/Assets/css/home/post.module.css";
import { styled } from "@mui/material/styles";
import { Avatar, Divider } from "@mui/material";
import { Button } from "@mui/material";
import location from "src/Assets/images/locationpinchildpost.png";
import crown from "src/Assets/images/crown.png";
import API from "../../../network";
import dot from "src/Assets/images/dot.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import Tooltip from "@mui/material/Tooltip";

const Container = styled("div")({
  backgroundColor: "#fff",
  margin: "20px",
  borderRadius: "20px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  boxSizing: "border-box",
});

const CrownDiv = styled("div")({
  alignSelf: "flex-end",
  marginBottom: "1px",
});

const Status = styled("div")({
  width: "12px",
  height: "12px",
  borderRadius: "12px",
  alignSelf: "flex-end",
  marginBottom: "6px",
});

const UserName = styled("div")({
  fontSize: "14px",
  fontWeight: "700",
  color: "#333",
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

const MessageTime = styled("div")({
  fontSize: "12px",
  color: "#373334",
  opacity: "85%",
});

const NameContainer = styled("div")({
  flex: 1,
  flexDirection: "column",
  display: "flex",
  minWidth: 0,
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

function ActionItems(props) {
  const { tenantId } = props || {};
  const { decreaseActionItemCount } = props;
  // const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [actionItems, setActionItems] = useState([]);
  const [isActionLoading, setIsActionLoading] = useState(true);
  const [activeTooltip, setActiveTooltip] = useState(null);

  useEffect(() => {
    getModeratorActionItems();
  }, [tenantId]);

  const getModeratorActionItems = async () => {
    // if (userDetails && Object.keys(userDetails).length !== 0) {
    if (tenantId) {
      setIsActionLoading(true);
      setActionItems([]);
      try {
        const response = await API.getModeratorActionItems(tenantId);
        if (
          response?.data?.messageList &&
          Array.isArray(response.data.messageList)
        ) {
          setActionItems(response.data.messageList || []);
          setIsActionLoading(false);
        }
      } catch (e) {
        console.error(e);
        setIsActionLoading(false);
      }
    }
  };

  const getFormData = (tenantId, messageId, category, requestType, userId) => {
    let approveIdsValue = "";
    if (category === "Message") {
      approveIdsValue = `msg_${messageId}`;
    } else if (category === "Request to follow community") {
      approveIdsValue = `followreq_${userId}_${tenantId}`;
    } else if (category === "Report abuse") {
      approveIdsValue = `abs_${messageId}`;
    } else if (category === "New moderator") {
      approveIdsValue = `user_${userId}_${tenantId}`;
    } else if (category === "Unblock user") {
      approveIdsValue = `unblockReq_${userId}_${tenantId}_${messageId}`;
    }

    approveIdsValue =
      requestType === "approve"
        ? `${approveIdsValue}_1`
        : `${approveIdsValue}_0`;
    console.info(approveIdsValue);

    let formData = new FormData();
    formData.append("approveIds", approveIdsValue);
    return formData;
  };

  const approveAction = (
    messageId,
    category,
    tenantId,
    userId,
    indexToRemove,
  ) => {
    const formData = getFormData(
      tenantId,
      messageId,
      category,
      "approve",
      userId,
    );
    API.moderatorApproveDeny(formData)
      .then((res) => {
        const updatedData = actionItems.filter(
          (_, index) => index !== indexToRemove,
        );
        setActionItems(updatedData);
        decreaseActionItemCount && decreaseActionItemCount();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getStatusTooltip = (Keyword_ID) => {
    switch (Keyword_ID) {
      case "Open ASK":
      case "OpenASK":
      case "ASK":
      case "A":
        return "ASK";

      case "SAY":
      case "OpenSAY":
      case "S":
        return "SAY";

      case "Important Update":
      case "UPDATE":
      case "impupdate":
      case "I":
        return "UPDATE";

      case "#tag":
      case "#TAG":
      case "hashTAG":
      case "H":
      case "X":
        return "TAG";

      default:
        return "";
    }
  };

  const getCurrentStatusColor = (Keyword_ID) => {
    switch (Keyword_ID) {
      case "Open ASK":
      case "OpenASK":
      case "ASK":
      case "A":
        return "#2168b2";
      case "SAY":
      case "OpenSAY":
      case "S":
        return "#45a735";
      case "Important Update":
      case "UPDATE":
      case "impupdate":
      case "I":
        return "#e82727";
      case "#tag":
      case "#TAG":
      case "hashTAG":
      case "H":
      case "X":
        return "#efba29";
      default:
        return "transparent";
    }
  };

  const onReject = async (
    messageId,
    category,
    tenantId,
    userId,
    indexToRemove,
  ) => {
    try {
      const formData = getFormData(
        tenantId,
        messageId,
        category,
        "reject",
        userId,
      );
      await API.moderatorApproveDeny(formData);
      const updatedData = actionItems.filter(
        (_, index) => index !== indexToRemove,
      );
      setActionItems(updatedData);
      decreaseActionItemCount && decreaseActionItemCount();
    } catch (e) {
      console.error(e);
    }
  };

  const getKey = (item) =>
    item?.messageId
      ? `key-messageId-${item.messageId}`
      : `key-userId-${item.userId}`;

  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  console.log(`actionItems:`, actionItems);

  return (
    <>
      {actionItems.length === 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "100px",
          }}
        >
          {isActionLoading ? (
            <div className="d-flex flex-direction-row justify-content-center">
              <CircularProgress size={30} />
            </div>
          ) : (
            <p>No Action Items are available !</p>
          )}
        </div>
      ) : (
        actionItems.map((item, index) => (
          <Container key={index}>
            <div style={{ display: "flex" }}>
              <Avatar
                src={`${profileImagePath}${
                  item.category === "Report abuse"
                    ? item.createdByImage
                    : item.userImage
                }`}
                className={styles.avatar}
                variant="square"
              />
              <NameContainer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <UserName>
                    {item.category === "Report abuse"
                      ? item.createdByName
                      : item.displayName}
                  </UserName>
                  {item.category === "Report abuse" && (
                    <UserName>
                      <span style={{ color: "#666" }}>Reported by </span>
                      <span>{item.displayName}</span>
                      <span style={{ color: "#666" }}> as </span>
                      <span>{item.reason}</span>
                    </UserName>
                  )}
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <MessageTime>{item.createdDate}</MessageTime>
                  {item.locName && (
                    <>
                      <img style={{ marginLeft: "3px" }} src={dot} alt="dot" />
                      <img
                        src={location}
                        style={{ width: 8, marginLeft: 7, marginRight: "3px" }}
                        alt="location"
                      />
                      <MessageTime>{item.locName}</MessageTime>
                    </>
                  )}
                </div>
              </NameContainer>
            </div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "baseline", // aligns with text bottom
                flexWrap: "wrap",
                gap: "5px", // small gap between text and file name
                width: "100%",
                maxWidth: "100%",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  color: "#333",
                  margin: "5px 0",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  maxWidth: "100%",
                }}
              >
                {item.message}
              </p>
              <PostAttachmentViewer
                docLocation={item.docLocation}
                docTagged={item.docTagged}
                docName={item.docName}
                messageID={item.messageId}
                activeTooltip={activeTooltip}
                setActiveTooltip={setActiveTooltip}
              />
            </div>
            {/* <div style={{ marginTop: "6px" }}>
            {item.followCount} followers. {item.hashTagType}
          </div> */}
            {String(item?.category).toLowerCase() === "new moderator" ? (
              <CrownDiv>
                <img src={crown} style={{ width: 12 }} alt="crown" />
              </CrownDiv>
            ) : (
              <Tooltip title={getStatusTooltip(item?.Keyword_ID)} arrow>
                <Status
                  style={{
                    backgroundColor: getCurrentStatusColor(item.Keyword_ID),
                    height: "13px",
                    width: "13px",
                    borderRadius: "36px",
                    marginRight: "10px",
                  }}
                />
              </Tooltip>
            )}
            <Divider variant="fullWidth" />
            {item?.category !== "Report abuse" ? (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    approveAction(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index,
                    )
                  }
                >
                  Approve
                </Button>
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    onReject(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index,
                    )
                  }
                >
                  Reject
                </Button>
              </div>
            ) : (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    onReject(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index,
                    )
                  }
                >
                  Ignore
                </Button>
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    approveAction(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index,
                    )
                  }
                >
                  Remove
                </Button>
              </div>
            )}
          </Container>
        ))
      )}
    </>
  );
}
export default ActionItems;
